import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useData } from '@hooks/useData';
import { useGetAllSettings } from '@services/useGetAllSettings';

export const SiteSetup = () => {
    const { allSettings } = useData();
    const { request: requestAllSettings } = useGetAllSettings();

    // call services, if we don't have the information yet
    useEffect(() => {
        if (!allSettings) {
            requestAllSettings();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allSettings]);

    return (
        <>
            <Outlet />
        </>
    );
};
